import { Component, ViewEncapsulation } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.' + environment.brand + '.html',
    styleUrls: ['./menu.component.' + environment.brand + '.scss'],
    encapsulation: ViewEncapsulation.None
})
export class MenuComponent {
    items: MenuItem[];

    constructor() {
        this.items = [
            {
                label: 'Models',
                url: 'https://www.audi.co.za/za/web/en/models.html'
            },
            {
                label: 'Own an Audi',
                url: 'https://www.audi.co.za/za/web/en/own-an-audi.html'
            },
            {
                label: 'Audi Service',
                url: 'https://www.audi.co.za/za/web/en/audi-service.html'
            },
            {
                label: 'News & Innovation',
                url: 'https://www.audi.co.za/za/web/en/keep-up-to-date.html'
            }
        ];
    }
}
